import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";

import PublicLayout from "./components/PublicLayout";
import AdminLayout from "./components/AdminLayout";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PackagesPage from "./pages/PackagesPage";
import PortfolioPage from "./pages/PortfolioPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import BookPage from "./pages/BookPage";
import { BookingSuccess, BookingCancelled } from "./pages/BookingResultPages";
import ContactPage from "./pages/ContactPage";
import IntakePage from "./pages/IntakePage";
import FAQPage from "./pages/FAQPage";
import PressPage from "./pages/PressPage";
import { BlogList, BlogPost } from "./pages/BlogPages";
import CreatorsPage from "./pages/CreatorsPage";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminClients from "./pages/admin/AdminClients";
import AdminProjects from "./pages/admin/AdminProjects";
import { AdminIntake, AdminContact, AdminNewsletter, AdminTestimonials, AdminPortfolio } from "./pages/admin/AdminSimple";
import { AdminBlog, AdminPress, AdminFAQs, AdminCreators, AdminAnnouncements, AdminTeam } from "./pages/admin/AdminMore";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/booking/cancelled" element={<BookingCancelled />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/intake" element={<IntakePage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/creators" element={<CreatorsPage />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverview />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="intake" element={<AdminIntake />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="newsletter" element={<AdminNewsletter />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="portfolio" element={<AdminPortfolio />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="press" element={<AdminPress />} />
              <Route path="faqs" element={<AdminFAQs />} />
              <Route path="creators" element={<AdminCreators />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="team" element={<AdminTeam />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
